import appConfig from "../config/AppConfig";

export const youtubeEmbedUrl = (value) => {
  try {
    const url = new URL(value);
    if (!["https:", "http:"].includes(url.protocol)) return null;
    const host = url.hostname.replace(/^www\./, "");
    let id;
    if (host === "youtu.be") id = url.pathname.split("/")[1];
    else if (["youtube.com", "m.youtube.com", "youtube-nocookie.com"].includes(host)) {
      id = url.pathname === "/watch" ? url.searchParams.get("v")
        : /^\/(embed|shorts|live)\//.test(url.pathname) ? url.pathname.split("/")[2] : null;
    }
    return /^[\w-]{11}$/.test(id || "") ? `https://www.youtube-nocookie.com/embed/${id}` : null;
  } catch { return null; }
};

export const resourceFileUrl = (resource) => {
  const value = resource.download_url || resource.url || resource.file_path;
  if (typeof value !== "string" || !value.trim()) return null;
  try {
    let path = value.trim();
    if (!/^https?:\/\//i.test(path)) {
      if (/^[a-z][a-z\d+.-]*:/i.test(path) || path.startsWith("//")) return null;
      path = path.replace(/^\/+/, "").replace(/^public\//, "");
      if (!path.startsWith("storage/")) path = `storage/${path}`;
      path = `/${path}`;
    }
    const url = new URL(path, `${appConfig.baseURL.replace(/\/$/, "")}/`);
    return ["http:", "https:"].includes(url.protocol) ? url.href : null;
  } catch { return null; }
};
